module.exports = __webpack_public_path__ + "static/media/solidDot.443fcbd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/apps/AppSearch/UI.AppBox/Icon/solidDot.svg
// module id = 4360
// module chunks = 0